import { useQuery } from '@tanstack/react-query';
import { TPO_GEN_DIM_OPTIONS_QUERY_KEY } from '../../../../utils/tpoGenQueryKeys';
import { tpoGenUrls } from 'config/urls';
import axios from 'axios';
import { type SelectOption } from '../../../../types/filters';
import { useMemo } from 'react';

interface EventProduct {
    dim1_id: number;
    dim1_name: string;
}

interface EventProductsResponse {
    event_id: string;
    products: EventProduct[];
    total_count: number;
}

const fetchEventProducts = async (eventId: string, signal?: AbortSignal): Promise<EventProductsResponse> => {
    const token = localStorage.getItem('accessToken');

    const response = await axios(tpoGenUrls.getEventProducts(eventId), {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
        },
        signal,
    });
    return response?.data;
};

const useProductAttributeFilters = ({ eventId }: { eventId: string }) => {
    const { data, isPending, isFetching, isError } = useQuery({
        queryKey: [TPO_GEN_DIM_OPTIONS_QUERY_KEY, 'product', eventId],
        queryFn: ({ signal }) => fetchEventProducts(eventId, signal),
        enabled: !!eventId,
    });

    const options = useMemo<SelectOption[]>(() => {
        if (!data?.products) return [];
        return data.products.map((p) => ({ label: p.dim1_name || String(p.dim1_id), value: String(p.dim1_id) }));
    }, [data]);

    return {
        options,
        isPending,
        isFetching,
        isError,
    };
};

export default useProductAttributeFilters;
